import { w as Ae } from "./context-B284KgoM.es.js";
import { w as $e } from "./withTheme-zx3wTAWo.es.js";
import o, { useCallback as oe, useState as O, useEffect as Y, useRef as Ne, useMemo as Pe } from "react";
import e from "prop-types";
import ne from "classnames/bind";
import { get as ce, has as Me, isArray as Be, filter as Fe } from "lodash";
import { useId as Ke } from "react-id-generator";
import { I as ze } from "./InputError-I0ejYOQJ.es.js";
import { I as He } from "./InputLabel-CinetSzC.es.js";
import ae from "classnames";
import { I as re } from "./Icon-BuIPTPJn.es.js";
import { T as Ue } from "./Tooltip-B-bmRvX4.es.js";
import { u as je, w as Ge } from "./utils-C0l876fA.es.js";
import { ChipContainer as Ze } from "./Chip/index.es.js";
import { L as we } from "./utils-Ci4OZEP4.es.js";
import './index13.css';const X = e.shape({
  label: e.string.isRequired,
  aliases: e.arrayOf(e.string),
  value: e.oneOfType([
    e.string,
    // Allow an array of values for 'select all'/'deselect all' option
    e.arrayOf(e.string)
  ]),
  count: e.number
}), Ve = e.shape({
  label: e.string.isRequired,
  value: e.string.isRequired
}), se = {
  label: e.string.isRequired,
  aliases: e.arrayOf(e.string),
  value: e.string
};
se.options = e.arrayOf(
  e.oneOfType([X, e.shape(se)]).isRequired
).isRequired;
const Ie = e.shape(se), Je = "SelectExpandIcon-module__disabled___qa9HQ", F = {
  "select-icon-size": "1.125rem",
  "select-icon-color": "#666",
  "select-icon-dark-color": "#fff",
  "select-icon-dark-color-disabled": "#666",
  "input-icon": "SelectExpandIcon-module__input-icon___5Nn-C",
  disabled: Je
}, We = (t, _, n) => t && !_ ? n ? F["select-icon-dark-color-disabled"] : F["select-icon-dark-color"] : F["select-icon-color"], de = ({ dark: t, expanded: _, searchIcon: n, disabled: p }) => /* @__PURE__ */ o.createElement(
  re,
  {
    name: n ? "search" : "arrow_down",
    size: F["select-icon-size"],
    className: ae([
      F["input-icon"],
      p && F.disabled
    ]),
    ariaHidden: !0,
    color: We(t, _, p),
    style: !n && _ ? {
      transform: "rotate(180deg)"
    } : {}
  }
);
de.propTypes = {
  dark: e.bool.isRequired,
  expanded: e.bool.isRequired,
  searchIcon: e.bool.isRequired,
  disabled: e.bool.isRequired
};
const Ye = "SelectInput-default-module__input___HZ55g", Xe = "SelectInput-default-module__dark___uTStS", Qe = "SelectInput-default-module__expanded___xyEOg", et = "SelectInput-default-module__disabled___b-2Yv", tt = "SelectInput-default-module__selectedText___X7RJx", lt = {
  input: Ye,
  dark: Xe,
  expanded: Qe,
  disabled: et,
  selectedText: tt
}, ot = "SelectInput-compere-module__input___a3Aqw", nt = "SelectInput-compere-module__dark___i4Pd1", rt = "SelectInput-compere-module__expanded___O4Nxo", st = "SelectInput-compere-module__disabled___FrUTB", ct = "SelectInput-compere-module__selectedText___81IID", at = {
  input: ot,
  dark: nt,
  expanded: rt,
  disabled: st,
  selectedText: ct
}, ge = {
  compere: at,
  default: lt
}, ie = ({
  expanded: t,
  value: _,
  selectedLength: n,
  alternateText: p,
  onChange: a,
  onEnter: y,
  onKeyDown: m,
  required: c,
  inputSearchIcon: h,
  dark: I,
  theme: A,
  toggleExpanded: $,
  selectText: D,
  ariaLabel: g,
  ariaDescribedBy: T,
  disabled: b,
  id: L
}) => {
  const S = (r, v) => {
    b || $(r, v);
  }, z = (r) => {
    r.key === "Enter" && y(), m(r);
  }, C = (r) => {
    t || S(!0, r), a(r);
  }, E = oe(() => !t && n === 0 ? p.placeholder : t ? p.focusPlaceholder : D || p.selectedFocusPlaceholder, [t, n, p, D]), [N, k] = O(E());
  Y(() => {
    k(E());
  }, [t, k, E, n]);
  const w = ce(ge, A, ge.default), i = Ne();
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ o.createElement(
      "div",
      {
        className: w.wrapper,
        onMouseDown: (r) => S(!t, r),
        onFocus: (r) => S(!0, r)
      },
      /* @__PURE__ */ o.createElement(
        "input",
        {
          ref: i,
          className: ae({
            [w.dark]: I,
            [w.input]: !0,
            [w.expanded]: t,
            [w.selectedText]: n > 0 && !t,
            [w.disabled]: b
          }),
          type: "text",
          role: "combobox",
          "aria-controls": "select-dropdown",
          "aria-haspopup": "listbox",
          "aria-expanded": t,
          id: L,
          "aria-labelledby": g,
          "aria-describedby": T,
          value: document.activeElement === i.current || t ? _ : "",
          placeholder: N,
          onKeyDown: z,
          "aria-required": c,
          tabIndex: "0",
          onChange: (r) => C(r),
          disabled: b
        }
      ),
      /* @__PURE__ */ o.createElement(
        de,
        {
          searchIcon: h,
          dark: I,
          expanded: t,
          disabled: b,
          "data-testid": "searchable-select-icon"
        }
      )
    )
  );
};
ie.propTypes = {
  value: e.string.isRequired,
  onChange: e.func.isRequired,
  onEnter: e.func,
  theme: e.string,
  dark: e.bool,
  required: e.bool,
  expanded: e.bool.isRequired,
  onKeyDown: e.func.isRequired,
  selectedLength: e.number.isRequired,
  alternateText: e.objectOf(e.string).isRequired,
  inputSearchIcon: e.bool.isRequired,
  toggleExpanded: e.func.isRequired,
  selectText: e.string,
  ariaLabel: e.string,
  ariaDescribedBy: e.string.isRequired,
  disabled: e.bool.isRequired,
  id: e.string
};
ie.defaultProps = {
  onEnter: () => {
  },
  theme: null,
  dark: !1,
  required: !1,
  selectText: null,
  ariaLabel: "",
  id: null
};
const dt = "SelectDropdownItem-compere-module__label___lvVmw", it = "SelectDropdownItem-compere-module__count___cu1Oz", ut = "SelectDropdownItem-compere-module__icon___wj7PS", _t = {
  "select-dropdown-icon-size": "1.25rem",
  label: dt,
  count: it,
  "dropdown-item": "SelectDropdownItem-compere-module__dropdown-item___bWy3J",
  "selected-label": "SelectDropdownItem-compere-module__selected-label___-DKc0",
  "pass-click": "SelectDropdownItem-compere-module__pass-click___uIdYf",
  icon: ut,
  "dropdown-item--parent": "SelectDropdownItem-compere-module__dropdown-item--parent___MToBf",
  "dropdown-item--italic": "SelectDropdownItem-compere-module__dropdown-item--italic___zK-91",
  "dropdown-item--level-1": "SelectDropdownItem-compere-module__dropdown-item--level-1___o0h-C",
  "tooltip-text": "SelectDropdownItem-compere-module__tooltip-text___El4V9"
}, pt = "SelectDropdownItem-default-module__label___6jUqp", mt = "SelectDropdownItem-default-module__count___gU6eb", ft = "SelectDropdownItem-default-module__icon___JWGz-", ht = {
  "select-dropdown-icon-size": "1.25rem",
  label: pt,
  count: mt,
  "dropdown-item": "SelectDropdownItem-default-module__dropdown-item___KBvrt",
  "selected-label": "SelectDropdownItem-default-module__selected-label___iZVyK",
  "pass-click": "SelectDropdownItem-default-module__pass-click___yd9o1",
  icon: ft,
  "dropdown-item--parent": "SelectDropdownItem-default-module__dropdown-item--parent___q-UDE",
  "dropdown-item--italic": "SelectDropdownItem-default-module__dropdown-item--italic___ZLqdB",
  "dropdown-item--level-1": "SelectDropdownItem-default-module__dropdown-item--level-1___1R2V1",
  "tooltip-text": "SelectDropdownItem-default-module__tooltip-text___MbxJH"
}, xe = {
  default: ht,
  compere: _t
}, ue = ({
  option: t,
  onOptionSelect: _,
  selected: n,
  italic: p,
  multiple: a,
  onExpand: y,
  deselectAllText: m,
  selectAllText: c,
  theme: h,
  language: I,
  level: A,
  handleSelectItemKeyDown: $,
  toggleExpanded: D,
  focusedIdx: g
}) => {
  const [T, b] = O(!1), [L, S] = O(!1), [z, C] = O(!1), E = o.useRef();
  Y(() => {
    const d = t.index === g;
    S(d), d && (E.current?.focus(), g !== 0 && E.current?.scrollIntoView(!0));
  }, [g, t.index]);
  const N = (d) => {
    d.stopPropagation(), t.value !== void 0 && (_(d, t.value), a || y(!1, d), C(!0));
  }, k = (d) => {
    const f = d.code === "Space";
    L && (d.key === "Enter" || f) ? (d.preventDefault(), N(d)) : d.key === "Escape" ? D(!1) : $(d);
  }, { t: w } = je(), i = ce(xe, h, xe.default), r = n.indexOf(t.value) !== -1, v = Me(t, "options") && t.options.length > 0, P = v ? t.options.filter((d) => n.indexOf(d.value) !== -1).length : 0, H = h === "compere" ? "green_check_compere" : "green_check";
  return /* @__PURE__ */ o.createElement("div", null, /* @__PURE__ */ o.createElement(
    "div",
    {
      ref: E,
      className: ne({
        [i["dropdown-item"]]: !0,
        [i["dropdown-item--parent"]]: v,
        [i["dropdown-item--italic"]]: p,
        [i[`dropdown-item--level-${A}`]]: !0,
        [i.label]: !0
      }),
      onClick: N,
      onMouseEnter: () => b(!0),
      onMouseLeave: () => {
        b(!1), C(!1), S(!1);
      },
      role: t.value ? "option" : "presentation",
      tabIndex: L ? "0" : "-1",
      "aria-selected": t.value ? r : void 0,
      onFocus: () => S(!0),
      onBlur: () => {
        S(!1), C(!1);
      },
      onKeyDown: k
    },
    t.label,
    t.count !== void 0 && /* @__PURE__ */ o.createElement("span", { className: i.count }, ` (${t.count.toLocaleString(I)})`),
    v && a && P > 0 && /* @__PURE__ */ o.createElement("span", { className: i["selected-label"] }, w("selectedTotalText", {
      selected: P,
      total: t.options.length
    })),
    r && (z ? /* @__PURE__ */ o.createElement(
      re,
      {
        className: i.icon,
        name: H,
        size: i["select-dropdown-icon-size"]
      }
    ) : /* @__PURE__ */ o.createElement("span", { className: i.icon }, /* @__PURE__ */ o.createElement(
      Ue.Hover,
      {
        dark: !0,
        placement: "left",
        trigger: /* @__PURE__ */ o.createElement(
          re,
          {
            name: T || L ? "red_x" : H,
            size: i["select-dropdown-icon-size"]
          }
        )
      },
      /* @__PURE__ */ o.createElement("p", { className: i["tooltip-text"] }, "Unselect")
    )))
  ), a && v && /* @__PURE__ */ o.createElement(
    K,
    {
      theme: h,
      key: `select-all-${t.value || t.label}`,
      option: {
        label: P === t.options.length ? m : c,
        value: t.options.map((d) => d.value),
        index: t.index + 1
      },
      onOptionSelect: _,
      selected: n,
      multiple: a,
      onExpand: y,
      italic: !0,
      deselectAllText: m,
      selectAllText: c,
      language: I,
      focusedIdx: g,
      level: A + 1,
      handleSelectItemKeyDown: $
    }
  ));
}, K = (t) => /* @__PURE__ */ o.createElement(ue, { ...t });
K.propTypes = {
  option: {
    ...X,
    index: e.number.isRequired
  }.isRequired,
  onOptionSelect: e.func.isRequired,
  selected: e.arrayOf(e.string.isRequired).isRequired,
  italic: e.bool,
  multiple: e.bool,
  deselectAllText: e.string.isRequired,
  selectAllText: e.string.isRequired,
  language: e.string.isRequired,
  theme: e.string,
  focusedIdx: e.number.isRequired,
  level: e.number.isRequired,
  onExpand: e.func.isRequired,
  handleSelectItemKeyDown: e.func,
  toggleExpanded: e.func
};
ue.propTypes = K.propTypes;
K.defaultProps = {
  italic: !1,
  multiple: !1,
  theme: null,
  handleSelectItemKeyDown: () => {
  },
  toggleExpanded: () => {
  }
};
ue.defaultProps = K.defaultProps;
const G = Object.freeze({
  // Set before any searching, or when the search term has been cleared.
  // Previously-selected options will be visible.
  READY: Symbol("READY"),
  // Set after a successful fetch. Currently-searched-for options will be
  // visible.
  COMPLETE: Symbol("COMPLETE"),
  // Set when a complete refresh of the results is in progress.
  ALL_LOADING: Symbol("ALL_LOADING"),
  // Set when a new set of results to be appended on to the options list is
  // being fetched.
  MORE_LOADING: Symbol("MORE_LOADING"),
  // Set when a complete refresh of the results fails.
  ALL_ERROR: Symbol("ALL_ERROR"),
  // Set when a fetch for results to append on to the options list fails.
  MORE_ERROR: Symbol("MORE_ERROR")
}), bt = "SelectDropdown-module__optionList___JckfC", St = "SelectDropdown-module__optionListItem___-dFa5", wt = "SelectDropdown-module__hr___oefRl", gt = "SelectDropdown-module__compere___4g4u6", W = {
  optionList: bt,
  optionListItem: St,
  hr: wt,
  compere: gt,
  default: "SelectDropdown-module__default___mLAdi"
}, Q = ({
  options: t,
  alternateBody: _,
  alternateFooter: n,
  showAll: p,
  level: a,
  isParent: y,
  status: m,
  ...c
}) => /* @__PURE__ */ o.createElement(
  "div",
  {
    role: _ ? "presentation" : "listbox",
    id: "select-dropdown",
    "aria-multiselectable": c.multiple,
    "aria-busy": m === G.ALL_LOADING,
    "aria-live": "polite"
  },
  _ ? /* @__PURE__ */ o.createElement("div", { role: "alert" }, _) : /* @__PURE__ */ o.createElement("ul", { className: W.optionList, role: y ? "group" : null }, t.map(
    (h, I) => !h.hidden && /* @__PURE__ */ o.createElement(
      "li",
      {
        className: W.optionListItem,
        key: h.value || `__category__${I}`
      },
      /* @__PURE__ */ o.createElement(
        K,
        {
          ...c,
          option: h,
          focusedIdx: c.focusedIdx,
          level: a
        }
      ),
      h.index < c.optionLength - 1 && /* @__PURE__ */ o.createElement(
        "hr",
        {
          className: ae(
            W[c.theme],
            W.hr
          )
        }
      ),
      h.options?.length ? /* @__PURE__ */ o.createElement(
        Q,
        {
          ...c,
          options: h.options,
          level: a + 1,
          isParent: !0
        }
      ) : null
    )
  ), n && /* @__PURE__ */ o.createElement(
    "div",
    {
      role: "alert",
      "aria-busy": c.status === G.ALL_LOADING,
      "aria-live": "polite"
    },
    n
  ))
), Z = (t) => /* @__PURE__ */ o.createElement(Q, { ...t });
Z.propTypes = {
  options: e.arrayOf(
    e.oneOfType([X, Ie]).isRequired
  ).isRequired,
  overrideMaxHeight: e.number,
  alternateBody: e.node,
  alternateFooter: e.node,
  showAll: e.bool,
  optionLength: e.number.isRequired,
  focusedIdx: e.number.isRequired,
  level: e.number,
  theme: e.oneOf(["compere", "default"]),
  multiple: e.bool,
  isParent: e.bool,
  status: e.oneOf(Object.values(G))
};
Q.propTypes = Z.propTypes;
Z.defaultProps = {
  overrideMaxHeight: void 0,
  alternateBody: null,
  alternateFooter: null,
  showAll: !1,
  level: 0,
  theme: "default",
  multiple: !1,
  isParent: !1,
  status: void 0
};
Q.defaultProps = Z.defaultProps;
const xt = "Select-compere-module__label___vreVx", yt = "Select-compere-module__disabled___GisZM", It = "Select-compere-module__select___nTxac", Et = "Select-compere-module__dark___ZMELF", Rt = "Select-compere-module__error___aou0m", Ot = "Select-compere-module__expanded___lMOJ3", Dt = "Select-compere-module__searchable___SyRcW", Tt = "Select-compere-module__chips___wcnK4", kt = "Select-compere-module__text___ESuD1", vt = "Select-compere-module__dropdown___0fsZw", qt = "Select-compere-module__darkOutline___gz0UD", Lt = {
  "select-top-wrapper": "Select-compere-module__select-top-wrapper___m1g-2",
  "in-text-input-select": "Select-compere-module__in-text-input-select___XEg5T",
  "label-container": "Select-compere-module__label-container___x-Yt7",
  label: xt,
  "selected-label": "Select-compere-module__selected-label___7HvXm",
  "select-wrapper": "Select-compere-module__select-wrapper___XLE7-",
  disabled: yt,
  "none-selected": "Select-compere-module__none-selected___Gn4Ay",
  select: It,
  dark: Et,
  "highlight-border": "Select-compere-module__highlight-border___XR69m",
  error: Rt,
  expanded: Ot,
  searchable: Dt,
  chips: Tt,
  text: kt,
  dropdown: vt,
  "max-height": "Select-compere-module__max-height___DRalC",
  "dropdown-item-focused": "Select-compere-module__dropdown-item-focused___eMtKz",
  darkOutline: qt
}, Ct = "Select-default-module__label___Cc4ol", At = "Select-default-module__disabled___ivDLM", $t = "Select-default-module__select___8Z8Zy", Nt = "Select-default-module__dark___kSjOg", Pt = "Select-default-module__error___5E5I1", Mt = "Select-default-module__expanded___BRxgu", Bt = "Select-default-module__searchable___KxSQV", Ft = "Select-default-module__chips___wLidP", Kt = "Select-default-module__text___feUh3", zt = "Select-default-module__dropdown___5aih2", Ht = "Select-default-module__darkOutline___7Qm1p", Ut = {
  "select-top-wrapper": "Select-default-module__select-top-wrapper___l3oVD",
  "in-text-input-select": "Select-default-module__in-text-input-select___OyFNU",
  "label-container": "Select-default-module__label-container___AORRB",
  label: Ct,
  "selected-label": "Select-default-module__selected-label___vTrhP",
  "select-wrapper": "Select-default-module__select-wrapper___ylZQt",
  disabled: At,
  "none-selected": "Select-default-module__none-selected___hLxYS",
  select: $t,
  dark: Nt,
  "highlight-border": "Select-default-module__highlight-border___2aqi-",
  error: Pt,
  expanded: Mt,
  searchable: Bt,
  chips: Ft,
  text: Kt,
  dropdown: zt,
  "max-height": "Select-default-module__max-height___BRa47",
  "dropdown-item-focused": "Select-default-module__dropdown-item-focused___xsJ1x",
  darkOutline: Ht
}, ye = {
  default: Ut,
  compere: Lt
}, V = (t) => {
  const {
    label: _,
    selected: n,
    disabled: p,
    multiple: a,
    inputSearchIcon: y,
    onSelect: m,
    searchable: c,
    onTextInput: h,
    textInput: I,
    alternateBody: A,
    alternateFooter: $,
    selectText: D,
    inTextInputSelect: g,
    dark: T,
    theme: b,
    showChips: L,
    chipOpts: S,
    dropdownShowAll: z,
    highlightWhenOptionSelected: C,
    onEnter: E,
    id: N,
    ariaLabelledBy: k,
    ariaDescribedBy: w,
    required: i,
    t: r,
    i18n: v,
    onExpand: P,
    status: H,
    showClearAll: d
  } = t, [f, _e] = O(!1), [M, B] = O(0), [ee, Ee] = O(null), te = (l, s = 0) => {
    const x = [...l];
    return x.forEach((u) => {
      u.index = s, s += 1, u.options?.length && (a ? (u.options = te(u.options, s + 1).opts, s = u.options[u.options.length - 1].index + 2) : (u.options = te(u.options, s).opts, s = u.options[u.options.length - 1].index + 1));
    }), { opts: x, optionLength: s };
  }, [Re, Oe] = O([]), [pe, De] = O(0);
  Y(() => {
    const l = te(t.options);
    Oe(l.opts), De(l.optionLength);
  }, [t.options, a]);
  const U = N || `${(k || _).replace(/\s+/g, "-").toLowerCase()}-select-id`, R = oe(
    (l, s) => {
      P(l), _e(l), !l && !c && (document.getElementById(U).focus(), s?.preventDefault()), B(c ? -1 : 0);
    },
    [P, c, _e, B, U]
  ), J = oe(
    (l) => {
      const { target: s } = l;
      f && ee && !ee.contains(s) && R(!1, l);
    },
    [f, R, ee]
  );
  Y(() => (document.removeEventListener("click", J), f && document.addEventListener("click", J), () => document.removeEventListener("click", J)), [f, J]);
  const Te = (l) => ({
    deselectAll: r("Deselect All"),
    focusPlaceholder: r("Start Typing..."),
    placeholder: r("None Selected"),
    selectAll: r("Select All"),
    selectedFocusPlaceholder: r("Add Another..."),
    clearAll: r("clear all"),
    showMoreChips: r("Show More Filter Chips"),
    showFewerChips: r("Show Fewer Filter Chips"),
    ...l
  }), ke = (l) => {
    p || R(!f, l);
  }, me = (l) => {
    l.key === "ArrowDown" && M < pe - 1 ? (l.preventDefault(), B(M + 1)) : l.key === "ArrowUp" && M > 0 ? (l.preventDefault(), B(M - 1)) : l.key === "Tab" && R(!1, l);
  }, fe = (l) => {
    if (l.key === "Escape")
      R(!1, l);
    else {
      const s = l.code === "Space";
      s && !c && l.preventDefault(), (l.key === "Enter" || s) && !f && (l.preventDefault(), R(!0, l));
    }
    c && me(l);
  }, ve = (l, s) => {
    if (Be(s)) {
      if (!a)
        throw new Error(
          "Cannot select multiple values in single select"
        );
      if (n.filter(
        (u) => s.indexOf(u) !== -1
      ).length === s.length)
        m(
          n.filter(
            (u) => s.indexOf(u) === -1
          )
        );
      else {
        const u = s.filter(
          (Ce) => n.indexOf(Ce) === -1
        );
        m([...n, ...u]);
      }
    } else {
      const x = n.indexOf(s) !== -1;
      m(
        a && x ? n.filter((u) => u !== s) : a && !x ? [...n, s] : x ? [] : [s]
      );
    }
  }, qe = (l) => {
    const s = Fe(n, (x) => x !== l);
    m(s);
  }, q = Te(t.alternateText), j = ce(ye, b, ye.default), le = ne.bind(j), Le = le({
    "select-wrapper": !0,
    dark: T,
    "none-selected": n.length === 0,
    error: !!t.error,
    disabled: p,
    multiple: a,
    expanded: f,
    searchable: c,
    "dropdown-item-focused": M >= 0,
    "in-text-input-select": g,
    "highlight-border": C && n.length > 0
  }), he = Pe(() => {
    const l = t.id ?? t.ariaLabelledBy ?? (t.label && t.label.toLowerCase().replace(/\s+/g, "-"));
    return l && t.error ? `${l}-error-message` : null;
  }, [t.id, t.ariaLabelledBy, t.label, t.error]), [be] = Ke(1, "baseselect-description-"), Se = `${w || be} ${he || ""}`;
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      className: le({
        "select-top-wrapper": !0,
        "in-text-input-select": g
      })
    },
    !g && _ && /* @__PURE__ */ o.createElement(
      He,
      {
        inputId: U,
        label: _,
        dark: T,
        multiple: a,
        selectedCount: n.length,
        onSelect: m,
        clearAllText: q.clearAll,
        theme: b,
        required: i,
        showClearAll: d
      }
    ),
    !w && /* @__PURE__ */ o.createElement("p", { hidden: !0, id: be }, r("selectedOptionsText", {
      selectedOptionText: D
    })),
    /* @__PURE__ */ o.createElement(
      "div",
      {
        className: Le,
        ref: (l) => {
          Ee(l);
        },
        "data-testid": "select-container"
      },
      c ? /* @__PURE__ */ o.createElement(
        ie,
        {
          theme: b,
          dark: T,
          value: I,
          alternateText: q,
          selectedLength: n.length,
          required: i,
          onChange: h,
          onEnter: E,
          expanded: f,
          onKeyDown: fe,
          tabIndex: f ? "-1" : "0",
          inputSearchIcon: y,
          toggleExpanded: R,
          selectText: D,
          ariaLabel: k,
          id: U,
          ariaDescribedBy: Se,
          disabled: p
        }
      ) : (
        /* Displays selected options text or placeholder */
        /* @__PURE__ */ o.createElement(
          "button",
          {
            className: ne(j.select, {
              [j.darkOutline]: t.dark
            }),
            type: "button",
            "aria-haspopup": "listbox",
            "aria-expanded": f,
            "aria-labelledby": k,
            "aria-describedby": Se,
            onKeyDown: fe,
            tabIndex: f ? "-1" : "0",
            onClick: ke,
            id: U,
            disabled: p
          },
          /* @__PURE__ */ o.createElement("span", { className: j.text }, D || q.placeholder),
          /* @__PURE__ */ o.createElement(
            de,
            {
              searchIcon: y,
              dark: T,
              expanded: f,
              disabled: p
            }
          )
        )
      ),
      f && H !== G.READY && /* @__PURE__ */ o.createElement(
        "div",
        {
          className: le({
            dropdown: !0,
            "max-height": !z
          })
        },
        /* @__PURE__ */ o.createElement(
          Z,
          {
            theme: b,
            options: Re,
            onOptionSelect: ve,
            selected: n,
            multiple: a,
            onExpand: R,
            deselectAllText: q.deselectAll,
            selectAllText: q.selectAll,
            selectedTotalText: q.selectedTotal,
            alternateBody: A,
            alternateFooter: $,
            language: v.language,
            focusedIdx: M,
            optionLength: pe,
            setFocusedIdx: B,
            handleSelectItemKeyDown: me,
            toggleExpanded: R,
            status: H
          }
        )
      )
    ),
    t.error && /* @__PURE__ */ o.createElement(ze, { dark: t.dark, id: he }, t.error),
    a && L && S.length ? /* @__PURE__ */ o.createElement("div", { className: j.chips }, /* @__PURE__ */ o.createElement(
      Ze,
      {
        theme: b,
        showFewerText: q.showFewerChips,
        showMoreText: q.showMoreChips,
        chips: S.map((l) => ({
          label: l.label,
          onDelete: () => qe(l.value)
        }))
      }
    )) : null
  );
};
V.displayName = "BaseSelect";
V.propTypes = {
  inTextInputSelect: e.bool.isRequired,
  label: we,
  options: e.arrayOf(
    e.oneOfType([
      X.isRequired,
      Ie.isRequired
    ])
  ).isRequired,
  selected: e.arrayOf(e.string.isRequired).isRequired,
  onSelect: e.func.isRequired,
  selectText: e.string.isRequired,
  disabled: e.bool,
  multiple: e.bool,
  inputSearchIcon: e.bool,
  onExpand: e.func,
  searchable: e.bool,
  textInput: e.string,
  onTextInput: e.func,
  alternateText: e.objectOf(e.string),
  alternateBody: e.node,
  alternateFooter: e.node,
  t: e.func.isRequired,
  i18n: e.shape({
    language: e.string.isRequired
  }).isRequired,
  theme: e.string,
  dark: e.bool,
  showChips: e.bool,
  chipOpts: e.arrayOf(Ve),
  dropdownShowAll: e.bool,
  highlightWhenOptionSelected: e.bool,
  onEnter: e.func,
  id: e.string,
  ariaDescribedBy: e.string,
  ariaLabelledBy: we,
  required: e.bool,
  error: e.string,
  status: e.oneOf(Object.values(G)),
  showClearAll: e.bool
};
V.defaultProps = {
  chipOpts: [],
  label: null,
  disabled: !1,
  multiple: !1,
  inputSearchIcon: !1,
  searchable: !1,
  textInput: "",
  onExpand: () => null,
  onTextInput: null,
  alternateText: {},
  alternateBody: null,
  alternateFooter: null,
  theme: "default",
  dark: !1,
  showChips: !1,
  dropdownShowAll: !1,
  highlightWhenOptionSelected: !1,
  onEnter: void 0,
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  required: !1,
  error: null,
  status: void 0,
  id: null,
  showClearAll: !1
};
V.displayName = "Select";
const jt = Ge(V), al = $e(Ae(jt));
export {
  Ie as C,
  X as O,
  al as S,
  de as a,
  Z as b,
  G as s
};
